// reducers/chat/index.js

import { combineReducers } from 'redux';
import { chat }            from './chat';
import { chatHasErrored }  from './chat';
import { chatIsLoading }   from './chat';
import { lexCB }            from './lexCB';
import { lexCBHasErrored }  from './lexCB';
import { lexCBIsLoading }   from './lexCB';

const chatReducers = combineReducers({
  chat,
  chatHasErrored,
  chatIsLoading
});

const lexCBReducers = combineReducers({
  lexCB,
  lexCBHasErrored,
  lexCBIsLoading
});

export default combineReducers({
  chat: chatReducers,
  lexCB: lexCBReducers
});